<!-- <input
  placeholder="search for location"
  autocorrect="off"
  autocapitalize="off"
  spellcheck="off"
  type="text"
  class="form-control"
  #search
  [formControl]="searchControl"
/> -->
<div class="input">
  <span><i class="fas fa-search"></i></span>
  <input
    [disabled]="disabled"
    nbInput
    fullWidth
    shape="round"
    [(ngModel)]="address"
    (change)="onQuery($event)"
    placeholder="{{ placeholderText }}"
    class="form-control h-auto"
    #search
    required
    onfocus="this.setAttribute('autocomplete', 'disabled')"
  />
</div>
<!-- onfocus="this.setAttribute('autocomplete', 'disabled')"
for fix error chrome autofill and google autocomplete conflict -->
